









import { Component, Vue, Watch, Inject, Prop } from 'vue-property-decorator';
@Component({})
export default class NumberDisplay extends Vue {
  @Prop() public value!: number;
  @Prop() public whiteMode!: boolean;
}
